import adapter from '#utils/logger/adapter/consoleAdapter';
import getConfigVars from '#utils/get-config-vars';

const logLevel = getConfigVars()?.LOG_LEVEL || 'error';

const LOG_LEVELS = {
  all: ['debug', 'info', 'warn', 'error'],
  info: ['info', 'warn', 'error'],
  debug: ['debug', 'warn', 'error'],
  warn: ['warn', 'error'],
  error: ['error'],
  off: [],
};

const getFormatterLog = (level, message, context) => {
  const contextObject = typeof context === 'object' ? context : { context };
  const log = {
    name: 'app',
    level,
    message,
    time: new Date().toISOString(),
    ...contextObject,
  };

  return JSON.stringify(log);
};

export default {
  error: (
    message: string | { [key: string]: unknown },
    context?: Record<string, unknown>
  ) => {
    if (LOG_LEVELS[logLevel].includes('error')) {
      adapter.error(getFormatterLog('ERROR', message, context));
    }
  },
  info: (
    message: string | { [key: string]: unknown },
    context?: Record<string, unknown>
  ) => {
    if (LOG_LEVELS[logLevel].includes('info')) {
      adapter.info(getFormatterLog('INFO', message, context));
    }
  },
  warn: (
    message: string | { [key: string]: unknown },
    context?: Record<string, unknown>
  ) => {
    if (LOG_LEVELS[logLevel].includes('warn')) {
      adapter.warning(getFormatterLog('WARN', message, context));
    }
  },
  debug: (
    message: string | { [key: string]: unknown },
    context?: Record<string, unknown>
  ) => {
    if (LOG_LEVELS[logLevel].includes('debug')) {
      adapter.debug(getFormatterLog('DEBUG', message, context));
    }
  },
};

export class Logger {
  context: string;
  logLevel: string;
  // eslint-disable-next-line @typescript-eslint/no-shadow
  constructor(context?: string, logLevel?: string) {
    this.context = context || '';
    this.logLevel = logLevel || getConfigVars().LOG_LEVEL;
  }
  error(message?: unknown, ...optionalParams: unknown[]) {
    if (LOG_LEVELS[this.logLevel].includes('error')) {
      console.error(`${this.context}`, message, ...optionalParams);
    }
  }
  info(message?: unknown, ...optionalParams: unknown[]) {
    if (LOG_LEVELS[this.logLevel].includes('info')) {
      console.info(`${this.context}`, message, ...optionalParams);
    }
  }
  warn(message?: unknown, ...optionalParams: unknown[]) {
    if (LOG_LEVELS[this.logLevel].includes('warn')) {
      console.warn(`${this.context}`, message, ...optionalParams);
    }
  }
  debug(message?: unknown, ...optionalParams: unknown[]) {
    if (LOG_LEVELS[this.logLevel].includes('debug')) {
      console.debug(`${this.context}`, message, ...optionalParams);
    }
  }
}
